import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { t } from '$i18n'

const StyledTypography = styled(Typography)`
  min-width: fit-content;
  margin-left: 5px;
`

interface Props {
  draft: string | undefined
}

export function MessageDraftPrefix({ draft }: Props) {
  if (!draft) return null

  return (
    <StyledTypography variant="body3" color="error" noWrap>
      {t('chatList.draft')}
    </StyledTypography>
  )
}
